<template>
  <div class="wrapper-quests">
      <LayoutNavAuth>
          <h1>{{__('Quests')}}</h1>

          <div slot="right" class="wrap-tabs pa-0">
              <tabs
                  :tabs="side_tabs"
                  :currentTab="currentTab"
                  :wrapper-class="'buttons-tabs'"
                  :tab-class="'buttons-tabs__item'"
                  :tab-active-class="'buttons-tabs__item_active'"
                  :line-class="'buttons-tabs__active-line'"
                  @onClick="sideChange"
              />
          </div>
          <div slot="right" class="wrap-select">
              <DropdownDefault
                  class_modal="modal_game"
                  color="select_game"
                  v-bind:dropdown="side_tabs"
                  v-bind:value.sync="side_tabs.value"
                  @updateValue="sideChange"
              />
          </div>

<!--          <div class="wrap-btn">-->
<!--              <div class="wrap-btn-search">-->
<!--                  <v-btn text v-ripple="false" class="btn-search" @click="changeClass">-->
<!--                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                          <ellipse cx="8.4819" cy="8.4819" rx="7.48191" ry="7.4819" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                          <path d="M13.6857 14.0743L16.6191 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                      </svg>-->
<!--                  </v-btn>-->
<!--              </div>-->
<!--          </div>-->
<!--          <div class="search" slot="right" ref="block_search">-->
<!--              <div class="search__icon">-->
<!--                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                      <ellipse cx="8.4819" cy="8.4819" rx="7.48191" ry="7.4819" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                      <path d="M13.6857 14.0743L16.6191 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                  </svg>-->
<!--              </div>-->
<!--              <div class="search__input">-->
<!--                  <SearchDefault-->
<!--                          style="width: 100%"-->
<!--                          v-model="search"-->
<!--                          :placeholder="__('Search quest ...')"-->
<!--                          class_search="games_search"-->
<!--                          v-on:keyup.enter="getQuests(currentTab)"-->
<!--                          @searching="getQuests(currentTab)"-->
<!--                  ></SearchDefault>-->
<!--              </div>-->
<!--              <div class="cancel-icon" @click="cancelSearch(currentTab)">-->
<!--                  <svg v-if="show" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                      <path d="M4.59548 4.00097L7.87669 0.719756C8.04111 0.555319 8.04111 0.288726 7.87669 0.124304C7.71225 -0.0401327 7.44564 -0.0401327 7.28122 0.124304L3.99999 3.40552L0.71878 0.124304C0.554343 -0.0401327 0.287749 -0.0401327 0.123328 0.124304C-0.0410937 0.288742 -0.0411093 0.555335 0.123328 0.719756L3.40454 4.00097L0.123328 7.28218C-0.0411093 7.44662 -0.0411093 7.71321 0.123328 7.87763C0.287765 8.04207 0.554358 8.04206 0.71878 7.87763L3.99999 4.59642L7.28119 7.87763C7.44563 8.04207 7.71223 8.04206 7.87666 7.87763C8.04108 7.7132 8.04108 7.4466 7.87666 7.28218L4.59548 4.00097Z" fill="currentColor"/>-->
<!--                  </svg>-->
<!--              </div>-->
<!--          </div>-->
          <div class="loading"  :style="{width: progress + '%'}"></div>
      </LayoutNavAuth>

      <div class="wrap-quests dashboard-content" v-show="data" v-if="quests">

          <h1 v-if="currentTab=='actual'">{{__('Actual quests')}}</h1>
          <h1 v-else>{{__('My quests')}}</h1>

          <div class="d-flex wrapper-quests" >
              <div class="block-quests">
                  <!--<div class="block-quests__head">
                      &lt;!&ndash;              <div class="block-title">&ndash;&gt;
                      &lt;!&ndash;                <img src="/dist/images/frontend/icon-quests.svg" alt />&ndash;&gt;
                      &lt;!&ndash;                <div>&ndash;&gt;
                      &lt;!&ndash;                  <p>Quests</p>&ndash;&gt;
                      &lt;!&ndash;                  <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi</span>&ndash;&gt;
                      &lt;!&ndash;                </div>&ndash;&gt;
                      &lt;!&ndash;              </div>&ndash;&gt;
                      &lt;!&ndash;<div class="block-tabs">&ndash;&gt;
                          &lt;!&ndash;<tabs&ndash;&gt;
                                  &lt;!&ndash;:tabs="side_tabs"&ndash;&gt;
                                  &lt;!&ndash;:currentTab="currentTab"&ndash;&gt;
                                  &lt;!&ndash;:wrapper-class="'default-tabs'"&ndash;&gt;
                                  &lt;!&ndash;:tab-class="'default-tabs__item'"&ndash;&gt;
                                  &lt;!&ndash;:tab-active-class="'default-tabs__item_active'"&ndash;&gt;
                                  &lt;!&ndash;:line-class="'default-tabs__active-line'"&ndash;&gt;
                                  &lt;!&ndash;@onClick="sideChange"&ndash;&gt;
                          &lt;!&ndash;/>&ndash;&gt;
                      &lt;!&ndash;</div>&ndash;&gt;

                      <h5 v-if="currentTab=='actual'">Actual quests</h5>
                      <h5 v-else>Archive</h5>

                      <div class="wrap-btn">
                          <v-btn text v-ripple="false" class="btn-search">
                              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.27778 3.63981C6.27778 5.0963 5.0963 6.2787 3.63889 6.2787C2.18148 6.2787 1 5.0963 1 3.63981C1 2.18241 2.18148 1 3.63889 1C5.0963 1 6.27778 2.18241 6.27778 3.63981Z" stroke="#002B50" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M9.93269 3.63984H16.2781" stroke="#002B50" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0006 12.8666C11.0006 11.4091 12.182 10.2277 13.6394 10.2277C15.0969 10.2277 16.2783 11.4091 16.2783 12.8666C16.2783 14.324 15.0969 15.5054 13.6394 15.5054C12.182 15.5054 11.0006 14.324 11.0006 12.8666Z" stroke="#002B50" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M7.34574 12.8666H1.00037" stroke="#002B50" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>

                          </v-btn>

                          <div class="search" slot="right">
                              <div class="search__icon">
                                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <ellipse cx="8.4819" cy="8.4819" rx="7.48191" ry="7.4819" stroke="#002B50" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      <path d="M13.6857 14.0743L16.6191 17" stroke="#002B50" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                              </div>
                              <div class="search__input">
                                  <SearchDefault
                                          v-model="search"
                                          style="width: 100%"
                                          placeholder="Search ..."
                                          class_search="games_search"
                                  ></SearchDefault>
                              </div>
                              <div class="cancel-icon">
                                  <svg v-if="show" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M4.59548 4.00097L7.87669 0.719756C8.04111 0.555319 8.04111 0.288726 7.87669 0.124304C7.71225 -0.0401327 7.44564 -0.0401327 7.28122 0.124304L3.99999 3.40552L0.71878 0.124304C0.554343 -0.0401327 0.287749 -0.0401327 0.123328 0.124304C-0.0410937 0.288742 -0.0411093 0.555335 0.123328 0.719756L3.40454 4.00097L0.123328 7.28218C-0.0411093 7.44662 -0.0411093 7.71321 0.123328 7.87763C0.287765 8.04207 0.554358 8.04206 0.71878 7.87763L3.99999 4.59642L7.28119 7.87763C7.44563 8.04207 7.71223 8.04206 7.87666 7.87763C8.04108 7.7132 8.04108 7.4466 7.87666 7.28218L4.59548 4.00097Z" fill="currentColor"/>
                                  </svg>
                              </div>
                          </div>
                      </div>
                  </div>-->

                  <div class="block-quests__body">

                      <AllQuests v-bind:info.sync="info" v-bind:data.sync="data" v-bind:quests.sync="quests" v-bind:progress.sync="progress" v-if="currentTab=='actual'"/>
                      <!--                <AllQuests v-if="currentTab=='quests'"/>-->
                      <MyQuests v-bind:data.sync="data" :search.sync="search" v-bind:quests.sync="quests" v-bind:progress.sync="progress" v-else-if="currentTab=='archive'"/>
                  </div>

              </div>
              <!--            <v-col cols="3" class="block-sorting">-->
              <!--                <QuestsSorting/>-->
              <!--            </v-col>-->
              <div class="sidebar-quest">
                  <div class="top-block" v-if="info && auth">
                      <h5>{{__('Exchange of experience for money')}}</h5>
                      <p>{{__('it is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.')}} </p>
                      <div class="wrapper-block-info" >
                          <div class="block-info">
                              <div class="block-info__icon">
                                  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M15.6339 0.000370618L12.2554 0.157381C11.9519 0.171132 11.8092 0.539141 12.024 0.753985L12.9774 1.70737L8.15645 6.52826L5.54612 3.91794C5.22993 3.60175 4.71729 3.60175 4.40111 3.91794L0.272364 8.04668C-0.090825 8.40987 -0.0907805 8.99874 0.272453 9.36184C0.635597 9.72489 1.22433 9.72485 1.58743 9.36175L4.97361 5.97557L7.58434 8.58629C7.90053 8.90248 8.41321 8.90248 8.72939 8.58629L14.2927 3.02261L15.2461 3.97595C15.4609 4.19079 15.8289 4.04811 15.8432 3.74457L15.9996 0.366124C16.009 0.160697 15.8393 -0.00900314 15.6339 0.000370618Z" fill="#3EB7FD"/>
                                      <path d="M12.9775 1.7074L14.2928 3.02269L12.7778 4.53783C12.7778 4.53783 13.3114 3.12261 12.5664 2.11856L12.9775 1.7074Z" fill="#26A9F4"/>
                                      <path d="M4.36165 6.58764L2.24694 8.70235C1.88742 9.06187 1.30452 9.06187 0.945003 8.70235C0.940626 8.69797 0.936248 8.69359 0.931871 8.68922C0.572352 8.3297 0.572352 7.7468 0.931871 7.38728L3.04658 5.27257C3.4061 4.91305 3.989 4.91305 4.34852 5.27257L4.36165 5.2857C4.72117 5.64522 4.72117 6.22812 4.36165 6.58764Z" fill="#6AC9FF"/>
                                      <path d="M2.06602 7.58166C2.06151 7.57715 2.05704 7.57269 2.05253 7.56818C1.6931 7.20875 1.6931 6.62599 2.05253 6.2666L2.27635 6.04278C2.63548 5.68366 3.21745 5.68344 3.57714 6.04194C3.58152 6.04632 3.58594 6.0507 3.59032 6.05507C3.95081 6.41437 3.95134 6.99793 3.59147 7.35784L3.3676 7.58171C3.00817 7.94109 2.42545 7.94109 2.06602 7.58166Z" fill="#6AC9FF"/>
                                      <path d="M12.3645 3.62242C12.3689 3.6268 12.3733 3.63118 12.3776 3.6356C12.7373 3.99521 12.7373 4.57823 12.3777 4.93784L8.72931 8.58635C8.41312 8.90254 7.90048 8.90258 7.58425 8.58635L6.51516 7.51726C6.15201 7.15411 6.15201 6.56534 6.51516 6.20219C6.8783 5.83905 7.46708 5.83905 7.83022 6.20219L8.15636 6.52833L11.0623 3.62247C11.4219 3.26282 12.0049 3.26281 12.3645 3.62242Z" fill="#6AC9FF"/>
                                      <path d="M11.4793 5.83639L10.3608 6.95483C10.0015 7.31422 9.41879 7.31422 9.05945 6.95483L9.04539 6.94077C8.68604 6.58142 8.68604 5.99879 9.04539 5.6394L10.1638 4.52096C10.5233 4.16153 11.1058 4.16184 11.4653 4.52114C11.4697 4.52552 11.4741 4.52989 11.4785 4.53427C11.8383 4.89379 11.8389 5.47673 11.4793 5.83639Z" fill="#6AC9FF"/>
                                  </svg>
                              </div>
                              <div class="block-info__text">
                                  <span>{{__('Completed')}} </span>
                                  <p v-if="auth && info">{{info.completed}}</p>
                                  <p v-else>0</p>
                              </div>

                          </div>

                          <div class="block-info">
                              <div class="block-info__icon" style="background: rgba(0, 196, 67, 0.15)">
                                  <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0107 5.33828C11.0945 6.27428 11.7143 7.42194 11.7143 8.99587C11.7143 12.275 9.15241 14.8571 6.00826 14.8571C2.86129 14.8571 0.285767 12.2732 0.285767 8.99587C0.285767 7.19093 0.676897 6.07543 1.82506 4.22127C2.18837 3.63457 3.07053 3.84823 3.13888 4.53948C3.2003 5.16061 3.38887 5.68932 3.66363 6.09466C3.48037 3.90438 4.43128 1.44108 6.77599 0.270815C7.31883 -0.000120252 7.92457 0.498352 7.78332 1.09976C7.41726 2.65835 7.79443 3.49687 8.78032 4.4002C8.80437 4.42223 8.92719 4.51291 9.08964 4.63283C9.38383 4.85002 9.80797 5.16315 10.0107 5.33828ZM2.15773 6.6289C1.95646 7.09747 1.71434 7.66113 1.71434 8.99581C1.71434 11.458 3.64368 13.3936 6.00826 13.3936C8.36858 13.3936 10.2858 11.4613 10.2858 8.99581C10.2858 7.89587 9.87479 7.13491 9.08993 6.45706C8.96604 6.35006 8.67564 6.13404 8.40232 5.93072C8.14388 5.73847 7.9007 5.55757 7.82794 5.4909C6.88142 4.62365 6.30277 3.70014 6.22417 2.46869C5.7456 2.94659 4.64594 4.43227 5.26575 7.3725C5.36184 7.8283 5.02277 8.25865 4.56756 8.25865C3.66438 8.25865 2.7716 7.55109 2.22596 6.46796C2.20407 6.52103 2.18118 6.57432 2.15773 6.6289Z" fill="#00C443"/>
                                      <path d="M10.0107 5.33828L9.94538 5.41396L10.0107 5.33828ZM1.82506 4.22127L1.74005 4.16862V4.16862L1.82506 4.22127ZM3.13888 4.53948L3.2384 4.52964L3.13888 4.53948ZM3.66363 6.09466L3.58085 6.15077L3.79512 6.46688L3.76328 6.08633L3.66363 6.09466ZM6.77599 0.270815L6.82065 0.36029L6.77599 0.270815ZM7.78332 1.09976L7.88067 1.12262L7.78332 1.09976ZM8.78032 4.4002L8.84788 4.32647H8.84788L8.78032 4.4002ZM9.08964 4.63283L9.14903 4.55238L9.08964 4.63283ZM2.15773 6.6289L2.06585 6.58944H2.06585L2.15773 6.6289ZM9.08993 6.45706L9.02456 6.53274L9.08993 6.45706ZM8.40232 5.93072L8.34263 6.01095L8.40232 5.93072ZM7.82794 5.4909L7.76038 5.56463V5.56463L7.82794 5.4909ZM6.22417 2.46869L6.32397 2.46232L6.30989 2.24177L6.15351 2.39793L6.22417 2.46869ZM5.26575 7.3725L5.3636 7.35187L5.26575 7.3725ZM2.22596 6.46796L2.31527 6.42297L2.21689 6.22768L2.13351 6.42983L2.22596 6.46796ZM11.8143 8.99587C11.8143 7.38985 11.1795 6.21552 10.0761 5.2626L9.94538 5.41396C11.0096 6.33304 11.6143 7.45403 11.6143 8.99587H11.8143ZM6.00826 14.9571C9.20961 14.9571 11.8143 12.3282 11.8143 8.99587H11.6143C11.6143 12.2217 9.09522 14.7571 6.00826 14.7571V14.9571ZM0.185767 8.99587C0.185767 12.3268 2.80441 14.9571 6.00826 14.9571V14.7571C2.91816 14.7571 0.385767 12.2196 0.385767 8.99587H0.185767ZM1.74005 4.16862C1.16425 5.09847 0.774724 5.84866 0.529826 6.59588C0.284502 7.34441 0.185767 8.08543 0.185767 8.99587H0.385767C0.385767 8.10137 0.482596 7.38217 0.719879 6.65817C0.957589 5.93288 1.33771 5.19823 1.91008 4.27392L1.74005 4.16862ZM3.2384 4.52964C3.16103 3.74725 2.15581 3.49721 1.74005 4.16862L1.91008 4.27392C2.22094 3.77193 2.98003 3.94921 3.03937 4.54932L3.2384 4.52964ZM3.7464 6.03855C3.48228 5.64891 3.29841 5.13664 3.2384 4.52964L3.03937 4.54932C3.10218 5.18457 3.29546 5.72974 3.58085 6.15077L3.7464 6.03855ZM6.73133 0.18134C4.34223 1.37376 3.37809 3.88134 3.56397 6.103L3.76328 6.08633C3.58265 3.92741 4.52034 1.5084 6.82065 0.36029L6.73133 0.18134ZM7.88067 1.12262C8.0399 0.44465 7.35538 -0.130125 6.73133 0.18134L6.82065 0.36029C7.28228 0.129885 7.80923 0.552053 7.68597 1.0769L7.88067 1.12262ZM8.84788 4.32647C8.36109 3.88045 8.03395 3.45877 7.86974 2.96419C7.70569 2.47006 7.70025 1.89082 7.88067 1.12262L7.68597 1.0769C7.50033 1.86729 7.50045 2.4866 7.67993 3.02721C7.85927 3.56737 8.21366 4.01662 8.71277 4.47393L8.84788 4.32647ZM9.14903 4.55238C9.06771 4.49234 8.99669 4.43991 8.94299 4.39974C8.91612 4.37964 8.89392 4.36285 8.8771 4.34985C8.86869 4.34335 8.86188 4.33799 8.85665 4.33377C8.85404 4.33167 8.85198 4.32997 8.8504 4.32864C8.84962 4.32798 8.84901 4.32746 8.84856 4.32707C8.84834 4.32688 8.84817 4.32673 8.84805 4.32662C8.84793 4.32652 8.84788 4.32647 8.84788 4.32647L8.71277 4.47393C8.72944 4.4892 8.7714 4.52114 8.82318 4.55988C8.87751 4.60053 8.94912 4.6534 9.03024 4.71328L9.14903 4.55238ZM10.0761 5.2626C9.86967 5.08431 9.44151 4.76831 9.14903 4.55238L9.03024 4.71328C9.32614 4.93173 9.74627 5.242 9.94538 5.41396L10.0761 5.2626ZM1.81434 8.99581C1.81434 7.67813 2.05216 7.12805 2.24961 6.66837L2.06585 6.58944C1.86076 7.06688 1.61434 7.64414 1.61434 8.99581H1.81434ZM6.00826 13.2936C3.70055 13.2936 1.81434 11.4045 1.81434 8.99581H1.61434C1.61434 11.5116 3.5868 13.4936 6.00826 13.4936V13.2936ZM10.1858 8.99581C10.1858 11.4081 8.31132 13.2936 6.00826 13.2936V13.4936C8.42584 13.4936 10.3858 11.5145 10.3858 8.99581H10.1858ZM9.02456 6.53274C9.79016 7.19395 10.1858 7.92835 10.1858 8.99581H10.3858C10.3858 7.86339 9.95942 7.07587 9.15529 6.38138L9.02456 6.53274ZM8.34263 6.01095C8.61792 6.21573 8.90422 6.4288 9.02456 6.53274L9.15529 6.38138C9.02785 6.27132 8.73337 6.05235 8.462 5.85048L8.34263 6.01095ZM7.76038 5.56463C7.83808 5.63582 8.08767 5.82128 8.34263 6.01095L8.462 5.85048C8.2001 5.65565 7.96332 5.47932 7.89549 5.41717L7.76038 5.56463ZM6.12437 2.47506C6.20511 3.7401 6.80151 4.68606 7.76038 5.56463L7.89549 5.41717C6.96133 4.56124 6.40042 3.66018 6.32397 2.46232L6.12437 2.47506ZM5.3636 7.35187C4.75145 4.448 5.83774 2.9959 6.29483 2.53945L6.15351 2.39793C5.65346 2.89727 4.54042 4.41653 5.1679 7.39313L5.3636 7.35187ZM4.56756 8.35865C5.08928 8.35865 5.47216 7.86688 5.3636 7.35187L5.1679 7.39313C5.25151 7.78973 4.95625 8.15865 4.56756 8.15865V8.35865ZM2.13665 6.51295C2.69122 7.6138 3.61152 8.35865 4.56756 8.35865V8.15865C3.71724 8.15865 2.85198 7.48838 2.31527 6.42297L2.13665 6.51295ZM2.24961 6.66837C2.27301 6.61391 2.29619 6.55994 2.3184 6.50609L2.13351 6.42983C2.11195 6.48211 2.08935 6.53473 2.06585 6.58944L2.24961 6.66837Z" fill="#00C443"/>
                                  </svg>
                              </div>
                              <div class="block-info__text">
                                  <span>{{__('Rating')}} </span>
                                  <p v-if="auth && info" style="color: #00C443">{{(info.rating != 0) ? '+' : ''}}{{info.rating}}</p>
                                  <p v-else style="color: #00C443">0</p>
                              </div>
                          </div>

                          <div class="block-info">
                              <div class="block-info__icon" style="background: rgba(224, 236, 253, 0.45)">
                                  <img src="/dist/images/frontend/light-coin.svg" alt />
                              </div>
                              <div class="block-info__text">
                                  <span>{{__('SILVER COIN')}} </span>
                                  <p  v-if="auth && info"  style="color: #607EA7">{{(info.silver != 0) ? '+' : ''}}{{info.silver}}</p>
                                  <p v-else style="color: #607EA7">0</p>
                              </div>
                          </div>

                          <div class="block-info" >
                              <div class="block-info__icon" style="background: rgba(255, 223, 142, 0.36)">
                                  <img src="/dist/images/frontend/money.svg" alt />
                              </div>
                              <div class="block-info__text">
                                  <span>{{__('GOLD COIN')}}</span>
                                  <p v-if="auth && info" style="color: #FDAE02">{{(info.gold != 0) ? '+' : ''}}{{info.gold}}</p>
                                  <p v-else style="color: #FDAE02">0</p>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="top-block">
                      <h5>{{__('Suggest your quest!')}}</h5>
                      <p>{{__('1it is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.')}} </p>
                      <div class="wrap-btn" v-if="auth">
                          <BaseButton :to="{name: 'chat', params: {id: 'support', lang: $store.getters.getLang}}">
                              <span>{{__('Suggest a quest')}}</span>
                          </BaseButton>
                      </div>
                      <div class="wrap-btn" v-else>
                          <BaseButton v-on:click="pushRegister">
                              <span>{{__('Suggest a quest')}}</span>
                          </BaseButton>
                      </div>
                  </div>
              </div>
          </div>

      </div>
      <div v-else>
          <div class="dashboard-content skleton-quest">
              <div class="left">
                 <SkeletonListAvatarLine :count="5"></SkeletonListAvatarLine>
              </div>
              <div class="right">
                  <div class="right">
                      <div class="top">
                          <SkeletonText class="text-top" :count="2"></SkeletonText>
                          <SkeletonListAvatarLine class="text" :count="4"></SkeletonListAvatarLine>
                      </div>
                      <div class="body">
                          <SkeletonText :count="2" class="text"></SkeletonText>
                          <SkeletonButton class="sklet-bottom"></SkeletonButton>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

    import AllQuests from  "./Quests/AllQuests";
    import MyQuests from  "./Quests/MyQuests";
    import LayoutNavAuth from "../modules/LayoutNavAuth";
    // import SearchDefault from "../modules/SearchDefault.vue"
    import SkeletonText from "../modules/SkeletonText";
    import SkeletonListAvatarLine from "../modules/SkeletonListAvatarLine";
    import DropdownDefault from "../modules/DropdownDefault";
    import SkeletonButton from "../modules/SkeletonButton";
    // import CompletedQuests from  "./Quests/MyQuests";
    // import QuestsSorting from  "./Quests/QuestsSorting";

    export default {
        name: 'Quests',
        data() {
            return {
                side_tabs: [
                    {
                        'title': 'Actual',
                        'value': 'actual'
                    },
                    {
                        'title': 'Archive',
                        'value': 'archive'
                    }
                ],

                tasks_list: null,
                property: null,
                loading_page: false,
                progress: 0,
                data: false,
                search: null,
                show: false,
                info: null,
                quests: null,
            }
        },

        watch: {
            search(val) {
                if (val) {
                    this.show = true;
                } else {
                    this.show = false;
                }
            }
        },
        computed: {
            currentTab: function () {
                return (this.$route.params.current) ? this.$route.params.current : 'actual'
            },
            auth() {
                return this.$store.state.auth.user;
            },
        },

        created() {
            this.getQuests(this.currentTab);

            // this.$addListener(window,'scroll', () => {
            //     this.scrollQuest();
            // });
        },
        methods: {
            pushRegister() {
                this.$store.commit('updateModalAuth', 'register');

            },
            changeClass() {
                this.$refs.block_search.classList.toggle('active');
            },
            sideChange(newTab) {
                if (newTab != this.currentTab) {
                    this.$router.push({name: 'quests_current', params: {'current': newTab, lang: this.$store.getters.getLang}});
                    // this.data = false;
                    this.getQuests(newTab);
                }
            },

            getQuests(newTab) {
                let timeout = setInterval(() => {
                    this.progress += 1;
                    if(this.progress > 50) {
                        clearInterval(timeout)
                    }
                },15);
                this.quests = null;
                let response = {
                    search: this.search
                };
                // this.$http.get("ajax/" + ((newTab == 'actual') ? "quest" : "quest/archive"))
                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']("ajax/" + ((newTab == 'actual') ? "quest" : "quest/archive"), response)
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        if(this.$checkAuth(response)) {
                            response = response.data;
                            this.quests = response;
                            this.data = true;
                            this.info = response.info;
                            // this.next_page_url = response.data.next_page_url;
                            clearInterval(timeout);
                            this.progress = 100;
                            setTimeout(() => {
                                this.progress = 0;
                            }, 500);

                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                    });
            },
            cancelSearch(newTab) {
                this.search = null;
                this.getQuests(newTab);
                this.$refs.block_search.classList.toggle('active');
            }
        },
        components: {

            SkeletonButton,
            SkeletonListAvatarLine,
            SkeletonText,
            AllQuests,
            MyQuests,
            LayoutNavAuth,
            // SearchDefault,
            DropdownDefault,
            // CompletedQuests,
            // QuestsSorting
        }
    }
</script>

<style lang="scss" scoped>

    .dark .wrap-quests {
        h1 {
            color: #fff;
        }
    }

    .wrapper-quests {
        //margin-right: 11px;
        //margin-left: 16px;
    }

    .wrap-quests {
        padding: 20px 0 0;

        h1 {
            font-size: 18px;
            line-height: 24px;
            color: #000000;
            margin-bottom: 20px;
        }
    }

    .dark .block-quests {
        &__body {
            background: #000303;
        }
    }

    .block-quests {
        /*background: #FFFFFF;*/
        //border-radius: 8px;
        //margin-left: -16px;
        //margin-right: 12px;
        width: calc(100% - 340px);

        &__head {
            //box-shadow: 0px 2px 0px #F2F3FB;
            border-radius: 4px 4px 0px 0px;
            padding: 0 20px;
            height: 64px;
            /*height: 120px;*/
            display: flex;
            justify-content: space-between;
            align-items: center;
            /*border-bottom: 2px solid #ECF4FF;*/
            position: relative;
            background-color: #fff;
            box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.06);

          /*&:after {*/
          /*  content: "";*/
          /*  position: absolute;*/
          /*  top: 0;*/
          /*  right: 0;*/
          /*  bottom: 0;*/
          /*  left: 0;*/
          /*  opacity: 0.3;*/
          /*  background: linear-gradient(90deg, #9CDFF9 0%, #87D6F5 31.01%, #C5DDF0 45.02%, #BDDBFC 64.06%, #D8E3F0 100%, #C5D6EA 100%);*/
          /*}*/

            h5 {
                font-size: 18px;
                line-height: 24px;
                white-space: nowrap;
            }

            .block-title {
                display: flex;
                align-items: center;
                position: relative;
                 z-index: 1;

                img {
                  margin-right: 30px;
                  height: 64px;
                }

                p {
                  font-weight: 400;
                  font-size: 18px;
                  line-height: 24px;
                  color: #002B50;
                  margin-bottom: 0;
                }

                span {
                  display: block;
                  font-size: 14px;
                  line-height: 18px;
                  color: #6886AF;
                  width: 78%;
                }
            }

          /*.block-tabs {*/
          /*  flex-shrink: 0;*/
          /*  display: flex;*/
          /*  align-items: flex-end;*/
          /*  position: relative;*/
          /*  z-index: 1;*/
          /*  transform: translateY(27px);*/
          /*}*/

            .v-btn.btn-search,
            .v-btn.btn-sorting {
                background: #F0F6FE;
                border-radius: 20px;
                transition: .3s;

                &.v-btn:not(.v-btn--round).v-size--default {
                    height: 40px;
                    min-width: 40px;
                    padding: 0;
                }

                &:hover {
                    background-color: #DFEAFC;
                    transition: .3s;
                }

                &.v-btn:before {
                    background-color: #DFEAFC;
                    transition: .3s;
                }

            }

            .wrap-btn {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: 100%;

                .search {
                    display: flex;
                    align-items: center;
                    padding-left: 20px;
                    margin-left: 20px;
                    border-left: 1px solid #E7F5FF;

                    &__icon {
                        /*margin-bottom: 3px;*/
                        svg  {
                            margin-right: 0;
                        }
                    }

                    .cancel-icon {
                        cursor: pointer;
                        width: 10px;

                        svg {
                            transition: .3s;
                            margin-right: 0;
                            color: #607EA7;
                        }

                        &:hover {
                            svg {
                                transform: scale(1.15);
                                transition: .3s;
                                color: #26A9F4;
                            }
                        }
                    }
                }

                .v-btn.btn-search,
                .v-btn.btn-sorting {
                    background: #fff;
                    border-radius: 8px;
                    transition: .3s;

                    &.v-btn:not(.v-btn--round).v-size--default {
                        height: 40px;
                        min-width: 40px;
                        padding: 0;
                    }

                    &:hover {
                        background-color: #E7F5FF;
                        transition: .3s;
                    }

                    &.v-btn:before {
                        background-color: #E7F5FF;
                        transition: .3s;
                    }

                }
            }
        }

        &__body {
          border-radius: 4px;
          background-color: #fff;
          /*min-height: calc(100vh - 170px);*/
          min-height: calc(100vh - 200px);
            margin-bottom: 15px;
          //overflow: auto;
        }
    }

    .dark .sidebar-quest .top-block {
        background: #171827;

        h5 {
            color: #fff;
        }

        p {
            color: #96AFD1;
        }

        .wrapper-block-info {
            .block-info {
                &__text {
                    span {
                        color: #96AFD1;
                    }
                }
            }
        }
    }

    .sidebar-quest {
        width: 320px;
        flex-shrink: 0;
        margin-left: 20px;

        .top-block {
            background: #FFFFFF;
            box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.05);
            border-radius: 4px;
            padding: 20px 20px 0;
            position: relative;
            margin-bottom: 20px;

            .bg-gold {
                position: absolute;
                right: 0;
                top: 0;
                z-index: +1;

                svg {
                    border-radius: 0 4px 0 0;
                }
            }

            .bg-silver {
                position: absolute;
                right: 0;
                top: 27px;
            }

            h5 {
                font-size: 18px;
                line-height: 24px;
                color: #002B50;
                margin-bottom: 10px;
                font-weight: 400;
            }

            p {
                font-size: 13px;
                line-height: 18px;
                color: #607EA7;
                margin-bottom: 20px;
            }

            .wrapper-block-info {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .block-info {
                    display: flex;
                    align-items: center;
                    width: 130px;
                    margin-bottom: 20px;

                    &__icon {
                        background: rgba(38, 169, 244, 0.15);
                        border-radius: 8px;
                        width: 42px;
                        height: 42px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 12px;

                        img {
                            height: 16px;
                        }
                    }

                    &__text {
                        span {
                            font-size: 13px;
                            line-height: 18px;
                            letter-spacing: 0.01em;
                            color: #6886AF;
                        }

                        p {
                            font-size: 20px;
                            line-height: 27px;
                            margin: 0;
                            color: #26A9F4;
                        }
                    }
                }
            }

            .wrap-btn {
                width: 154px;
                padding-bottom: 20px;
            }

        }
    }

    @media screen and (max-width: 1240px){
        .wrap-quests {
            padding: 20px 20px 0;
        }
    }

    @media screen and (max-width: 950px) {
        .wrapper-quests {
            flex-direction: column-reverse;
        }
        .sidebar-quest {
            width: 100%;
            margin-left: 0;

            .top-block {
                padding: 10px 10px 0;

                &:nth-child(2) {
                    display: none;
                }
                h5 {
                }

                p {
                    font-size: 14px;
                }
                .wrapper-block-info {
                    margin-right: 70px;

                    .block-info {
                        margin-right: 10px;
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 800px) {
      .block-quests {
        &__head {

          .block-title {

            span {
              width: 95%;
            }
          }

        }
      }
    }

    @media screen and (max-width: 768px){
        .wrap-quests {
            padding: 20px 15px 0;
        }
        .sidebar-quest {
            .top-block {
                margin-bottom: 15px;
            }
        }
    }

    @media screen and (max-width: 550px){
        .sidebar-quest {
            .top-block {
                padding: 10px 12px 0;

                h5 {
                }

                p {
                    font-size: 12px;
                }
                .wrapper-block-info {
                    margin-right: 0;

                    .block-info {
                        margin-right: 0;
                        margin-bottom: 10px;

                        &__icon {
                            width: 36px;
                            height: 36px;
                            margin-right: 10px;
                        }

                        &__text {

                            span {
                                font-size: 12px;
                            }
                            p {
                                max-width: fit-content;
                                font-size: 16px;
                                line-height: 20px;
                            }
                        }
                    }
                }

                .bg-gold {
                    svg {
                        width: 108px;
                        height: 80px;
                    }
                }

                .bg-silver {
                    top: 25px;
                    svg {
                        width: 50px;
                        height: 87px;
                    }
                }
            }
        }
    }
</style>